// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 929 ? "babylon" : chunkId) + "." + {"118":"9cb7432a","375":"08ba80df","929":"bdfe55ae"}[chunkId] + ".chunk.js";
};